// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2573":"dee499e3","2866":"2bc78d98","3390":"16d9f833","3481":"dee499e3","7220":"54015e4f","8025":"dee499e3","8125":"1fd9c1f8"}[chunkId] + ".chunk.css";
};